export default __webpack_public_path__ + "static/media/logo.870053c9.svg";